export default __webpack_public_path__ + "static/media/login-right-image.a8085ca2.svg";